// extracted by mini-css-extract-plugin
export default {"customers":"nR","wrapper":"oR","carousel":"pR","carousel_inner_wrapper":"qR","top_quote":"rR","bottom_quote":"sR","carousel_wrapper":"tR","feedbacks_wrapper":"uR","arrows":"vR","prev":"wR","img":"xR","review_btn":"yR"};
    if(module.hot) {
      // 1713361653339
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  